import { NgModule } from '@angular/core';
import { SharedModule } from 'app/components/shared.module';
import { SectionModule } from 'app/views/presentations/layouts/layouts/section.module';
import { TwoSectionsHorizontalLayoutMirror, TwoSectionsHorizontalLayoutMirrorComponent } from 'app/views/presentations/layouts/layouts/twoSectionsHorizontalLayoutMirror/twoSectionsHorizontalLayoutMirror.component';
import { LayoutWrapperModule } from 'app/views/presentations/layouts/layoutWrapper.module';

@NgModule({
    imports: [
        SharedModule,
        SectionModule,
        LayoutWrapperModule.wrapLayout(TwoSectionsHorizontalLayoutMirror)
    ],
    declarations: [
        TwoSectionsHorizontalLayoutMirrorComponent
    ],
    entryComponents: [
        TwoSectionsHorizontalLayoutMirrorComponent
    ]
})
export class TwoSectionsHorizontalLayoutMirrorModule { }


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/twoSectionsHorizontalLayoutMirror/twoSectionsHorizontalLayoutMirror.module.ts